<template>
  <v-container fluid class="ma-0 pa-0" style="background: #0D1F2B;">
    <!-- DESKTOP -->
    <v-container
      fluid
      class="d-none d-lg-block primary text-white text-center text-h6"
      style="font-family: Montserrat;"
    >
      <v-row
        style="position: absolute; left: 0; bottom: 0;"
        class="ma-0 pa-0 ml-2 mb-2"
      >
        <v-btn variant="text" color="white" @click="openComplaint">
          {{ $t('complaint_portal') }}
        </v-btn>
      </v-row>

      {{ new Date().getFullYear() }} — 
      <strong>{{ $t('developed_by') }} Dreamdeal Technologies</strong>

      <v-row
        style="position: absolute; right: 0; bottom: 0;"
        class="ma-0 pa-0"
      >
        <v-btn
          variant="text"
          color="white"
          @click="openPrivacy"
        >
          {{ $t('privacy_label') }}
        </v-btn>

        <v-btn
          v-for="sn in social_networks"
          :key="sn.icon"
          class="mb-2"
          icon
          variant="text"
          color="white"
          @click="goTo(sn)"
        >
          <v-icon size="28px">{{ sn.icon }}</v-icon>
        </v-btn>
      </v-row>
    </v-container>

    <!-- MOBILE -->
    <v-container
      fluid
      class="d-lg-none primary text-white text-center text-caption"
      style="font-family: Montserrat;"
    >
      <v-row>
        <v-col cols="12">
          <v-btn
            v-for="sn in social_networks"
            :key="sn.icon"
            icon
            variant="text"
            color="white"
            @click="goTo(sn)"
          >
            <v-icon size="28px">{{ sn.icon }}</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="12" class="mt-n4">
          {{ new Date().getFullYear() }} — 
          <strong>{{ $t('developed_by') }} Dreamdeal Technologies</strong>
        </v-col>

        <v-col cols="12" class="mt-n4">
          <v-btn
            x-small
            variant="text"
            color="white"
            @click="openPrivacy"
          >
            {{ $t('privacy_label') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { locale } = useI18n({ useScope: 'global' })

const social_networks = [
  {
    icon: 'mdi-linkedin',
    url: 'https://www.linkedin.com/company/dreamdeal-technologies/'
  },
  {
    icon: 'mdi-facebook',
    url: 'https://www.facebook.com/dreamdealtech'
  }
]

function openComplaint () {
  window.open(
    'https://complaint.ignoto.eu/cfca53e394dd7223-dd8817ade4a29960',
    '_blank'
  )
}

function openPrivacy () {
  window.open('/' + String(locale.value) + '/privacy', '_blank')
}

function goTo (social) {
  window.open(social.url, '_blank')
}
</script>
